<template>
  <div>
    <Head />
    <Navigation />
    <Wallpaper :src="src"/>
    <Content :title="title" :items="items"  v-bind="$attrs"/>
    <foot />
  </div>
</template>

<script>
import Head from '@/components/index/components/head'
import Wallpaper from '../components/wallpaper'
import Content from '../components/content'
import Foot from '@/components/index/components/foot'
import Navigation from '@/components/index/components/nav'
export default {
  name: 'Technicals',
  components: {
    Head,
    Foot,
    Navigation,
    Wallpaper,
    Content
  },
  data () {
    return {
      src: 'technical/toppic.gif',
      title: '技术服务',
      items: [
        {listName:'多体运动模拟',url:'/technical/1'},
        {listName:'结构分析与优化',url:'/technical/2'},
        {listName:'参数化建模与设计校验',url:'/technical/3'},
        {listName:'IT架构与系统建模',url:'/technical/4'},
        {listName:'工艺工序过程模拟',url:'/technical/5'},
        {listName:'多物理场耦合虚拟仿真',url:'/technical/6'},
        {listName:'数据可视化与场景化',url:'/technical/7'},
        {listName:'数据采集与实时监控',url:'/technical/8'}
      ]
    }
  }
}
</script>

<style scoped>

</style>
